module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.showFirstLoginSurveyModal) ? _c('modal', {
    on: {
      "close": _vm.logoutUser
    }
  }, [_c('first-login-survey', {
    on: {
      "close": _vm.closeFirstLoginSurveyModal
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb238fae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/dashboard.vue
// module id = 1232
// module chunks = 0